import { render } from "./Detail_acteur.vue?vue&type=template&id=cb988dbe&scoped=true"
import script from "./Detail_acteur.vue?vue&type=script&lang=js"
export * from "./Detail_acteur.vue?vue&type=script&lang=js"

import "./Detail_acteur.vue?vue&type=style&index=0&id=cb988dbe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\HP\\Desktop\\Vuejsproject\\final\\yajobici-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb988dbe"]])

export default __exports__